import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useParams, Link } from "react-router-dom";
import "./blog-details.css";

const allPosts = [
  {
    id: 1,
    title: "How Financial Planning Helps You Win 2025",
    date: "2025-08-20",
    content:
      "Financial planning is key to success. In this blog, we break down the reasons why planning early is a winning move. Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living.Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living. Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living.",
  },
  {
    id: 2,
    title: "Why Budgeting Matters More Than Ever",
    date: "2025-08-14",
    content:
      "Budgeting helps reduce unnecessary expenses and keeps your goals on track. Financial planning is key to success. In this blog, we break down the reasons why planning early is a winning move. Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living.Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living. Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living.",
  },
  {
    id: 3,
    title: "The Truth About Credit Scores in India",
    date: "2025-08-05",
    content:
      "Your credit score can impact loan approvals and rates. Learn how to improve it. Financial planning is key to success. In this blog, we break down the reasons why planning early is a winning move. Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living.Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living. Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living.",
  },
];

const BlogDetails = () => {
  const { id } = useParams();
  const post = allPosts.find((p) => p.id === parseInt(id));
  const latest = allPosts
    .filter((p) => p.id !== parseInt(id))
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  if (!post) return <div>Blog not found.</div>;

  return (
    <section className="blog-details-section py-5">
      <div className="container">
        <div className="row align-items-start">
          {/* Main Blog Content */}
          <div className="col-lg-8">
            <h2 className="details-title" data-aos="fade-up">
              {post.title}
            </h2>
            <p className="details-date" data-aos="fade-up">
              {new Date(post.date).toLocaleDateString()}
            </p>
            <img
              src={`https://picsum.photos/800/400?random=${post.id}`}
              alt={post.title}
              className="img-fluid details-img mb-4"
              data-aos="zoom-in"
            />
            <p className="details-content" data-aos="fade-up">
              {post.content}
            </p>
          </div>

          {/* Sidebar Latest Posts with responsive top padding */}
          <div className="col-lg-4 sidebar-padding">
            <div className="latest-blogs-sidebar" data-aos="fade-left">
              <h4 className="sidebar-title">Latest Blogs</h4>
              <hr />
              {latest.map((p) => (
                <Link
                  to={`/blog-details/${p.id}`}
                  className="latest-blog-card d-flex align-items-start gap-3 mb-3"
                  key={p.id}
                >
                  <img
                    src={`https://picsum.photos/60/60?random=${p.id}`}
                    alt={p.title}
                    className="latest-thumb"
                  />
                  <div className="flex-grow-1">
                    <h6 className="latest-title">{p.title}</h6>
                    <span className="latest-date">
                      {new Date(p.date).toLocaleDateString()}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetails;
